import { Component } from '@opten/compiler/metadata/component';
import { hideMegaDropdown } from './mega-dropdown';

@Component({ className: 'js-notification' })
export class NotificationComponent {
	close: HTMLElement;
	backdrop: HTMLElement;
	constructor(private element: HTMLElement) {
		this.close = this.element.querySelector<HTMLElement>(
			'.js-notification-close'
		);
		this.backdrop = document.querySelector<HTMLElement>(
			'.js-notification-backdrop'
		);

		this.close.addEventListener('click', () => {
			hideMegaDropdown(this.element, this.backdrop);
			this.setSessionCookie();
		});

		const links = this.element.querySelectorAll('a');
		links.forEach(link =>
			link.addEventListener('click', () => this.setSessionCookie())
		);
	}

	setSessionCookie() {
		document.cookie = 'hypi-alert=1;path=/;samesite=strict;secure';
	}
}
